import styled from '@emotion/styled';

export const ImgContainer = styled('img')({
  cursor: 'pointer',
  marginRight: '10px',
});
